import React, { Component } from "react";
import { Form, Input, Button, message, notification, Checkbox } from 'antd';
import { ReCaptcha } from 'react-recaptcha-google';
import background from "../img/mamca-bg.jpg";
import "./Signup.css";

class SignupFree extends Component {
    constructor(props) {
        super(props);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.state = {
            confirmDirty: false,
            autoCompleteResult: [], // can be used later
            feedback: "", // used to set the input status
            loading: false,
            recaptchaToken: "",
        };
    }

    verifyCallback(result) {
        this.setState({ recaptchaToken: result });
    }

    // Function for signup
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                this.setState({ feedback: "error" });
            }
            // Check if the activation code matches
            if (values.activationCode !== this.state.activationCode) {
                message.error("Invalid activation code!");
                return;
            }

            if (!err && values.terms) {
                this.setState({ loading: true }); // button start loading
                if (this.state.recaptchaToken.length !== 0) {
                    fetch('/login/signupfree', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            email: values.email,
                            password: values.password,
                            organization: values.organization,
                        }),
                    })
                        .then((res) => res.json())
                        .then((json) => {
                            if (json.success) {
                                notification.open({
                                    message: 'Congratulation!',
                                    description: 'You have created a new account, now you can log in the MAMCA software with your account.',
                                });
                                this.setState({ loading: false });
                                this.props.history.push('/login', { newAccount: true }); // created successfully, redirect to login page
                            } else {
                                this.setState({ loading: false });
                                message.error(json.message); // create unsuccessful, show json message
                            }
                        });
                } else {
                    message.error("You must pass the reCaptcha check!");
                    this.setState({ loading: false });
                }
            } else {
                message.error("You must agree to the Terms of Use!");
                this.setState({ loading: false });
            }
        });
    };

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    // Confirm the password is correct or not
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            this.setState({ feedback: "error" });
            callback('Two passwords that you enter are inconsistent!');
        } else {
            this.setState({ feedback: "success" });
            callback();
        }
    };

    // Confirm the password after entering value
    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div style={{ backgroundImage: "url(" + background + ")" }} className="Signup">
                <Form onSubmit={this.handleSubmit} className="login-form">
                    <Form.Item label="E-mail">
                        {getFieldDecorator('email', {
                            rules: [
                                { type: 'email', message: 'The input is not a valid E-mail!' },
                                { required: true, message: 'Please input your E-mail!' },
                            ],
                        })(<Input size="large" />)}
                    </Form.Item>

                    <Form.Item label="Password" hasFeedback validateStatus={this.state.feedback}>
                        {getFieldDecorator('password', {
                            rules: [
                                { required: true, message: 'Please input your password!' },
                                { validator: this.validateToNextPassword },
                            ],
                        })(<Input size="large" type="password" />)}
                    </Form.Item>

                    <Form.Item label="Confirm Password" hasFeedback validateStatus={this.state.feedback}>
                        {getFieldDecorator('confirm', {
                            rules: [
                                { required: true, message: 'Please confirm your password!' },
                                { validator: this.compareToFirstPassword },
                            ],
                        })(<Input size="large" type="password" onBlur={this.handleConfirmBlur} />)}
                    </Form.Item>

                    <Form.Item label="Organization">
                        {getFieldDecorator('organization', {
                            rules: [{ required: true, message: 'Please input your organization!' }],
                        })(<Input size="large" />)}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('terms', {
                            rules: [{ required: true, message: 'You must agree to the Terms of Use' }],
                        })(
                            <Checkbox>
                                I agree to the
                                <a
                                    href="https://res.cloudinary.com/ddwpezn3f/image/upload/v1729970950/VUB/Use_Agreement_MAMCA_Terms_of_Use_New.pdf"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <b style={{ color: "rgba(0, 0, 0, 1)" }}> Terms of Use</b>
                                </a>
                            </Checkbox>
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('captcha', {
                            rules: [{ required: false, message: 'Please input the captcha you got!' }],
                        })(
                            <ReCaptcha
                                render="explicit"
                                sitekey="6LctSLsUAAAAACZ6pVEqkLaiVXzSYpDWhDAhGEtI"
                                onloadCallback={() => {}}
                                verifyCallback={this.verifyCallback}
                            />
                        )}
                    </Form.Item>

                    <Form.Item style={{ marginTop: "5vh" }}>
                        <Button
                            size="large"
                            type="primary"
                            htmlType="submit"
                            loading={this.state.loading}
                            style={{ width: "100%" }}
                        >
                            Register
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

SignupFree = Form.create({})(SignupFree); // create form which can access the data

export default SignupFree;
